import { h } from 'preact';

import SectionTitle from '../../../components/2-atoms/section-title/section-title';
import DropdownFloating from '../../../components/3-molecules/dropdown/dropdown-floating';
import { ParselyWrapper, ParselyBody, ParselyTop } from '../parsely-wrapper';
import ParselySkeleton from '../parsely-skeleton';

export function renderParselySkeleton({ derivedValues, widget, htmlProps, userHasPreferences, maxContents }) {
  return (
    <ParselyWrapper>
      <ParselyTop>
        <SectionTitle modifiers={derivedValues.sectionTitleModifiers}>{derivedValues.title}</SectionTitle>
        {derivedValues.showRemoveConsent && <DropdownFloating options={[]} />}
      </ParselyTop>
      <ParselyBody>
        <ParselySkeleton
          skeletonColor={widget.styles.skeletonColor}
          setsOfCardsModifiers={widget.styles.setsOfCardsModifiers}
          cardModifiers={widget.styles.cardModifiers[htmlProps.position]}
          maxContents={maxContents}
          isCtaActive={widget.isCtaActive && userHasPreferences}
        />
      </ParselyBody>
    </ParselyWrapper>
  );
}
